/**
 * BiCommandCenterBanner — Contextual framing for the BI Command Center page.
 *
 * Static banner explaining:
 *   - This is a platform-operator view (cross-tenant, super-admin-only)
 *   - It is read-only in Phase 4.8 — workflow actions ship in Phase 4.10
 *   - Tenant-facing consumption is on the tenant My Capabilities page (Phase 4.9)
 *   - It is the foundation for Phase 4.10 wizards + orchestrator
 *
 * WQ-226 — Documentation Bridge (v5.217.0)
 */
import React from 'react';

const BiCommandCenterBanner: React.FC = () => {
  return (
    <div
      data-testid="bi-cc-banner"
      style={{
        marginBottom: 20,
        padding: '14px 18px',
        borderLeft: '4px solid var(--color-primary, #2563eb)',
        background: 'var(--color-bg-subtle, rgba(37, 99, 235, 0.06))',
        borderRadius: 6,
        fontSize: 14,
        lineHeight: 1.55,
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 6 }}>
        Platform-operator view · cross-tenant · read-only (Phase 4.8 substrate)
      </div>
      <div>
        BI Command Center is the platform operator's window into ML infrastructure across
        all tenants — algorithms, data sources, AutoML, predictions, fairness,
        explainability, quality, model health, security, and agent observations. It is
        currently read-only. Workflow actions (Compose Dataset, Start AutoML, Request
        Prediction, Submit for Commissioning) ship as wizards in Phase 4.10 (Workflow &
        Orchestration Fabric). Tenant-facing consumption — the subset of these
        capabilities a given tenant has been allocated, with usage and quota visibility —
        lands on the tenant <em>My Capabilities</em> page in Phase 4.9 (Allocation &amp;
        Metering Fabric). This console is the foundation those phases build on; see
        ADR-015 (Platform Control Plane vs Tenant Consumption Surface), Addendum: Control
        Plane Layers.
      </div>
    </div>
  );
};

export default BiCommandCenterBanner;
